export const PARTNER_ADDRESS_TABLE = "partner-addresses"
export const PARTNER_ADDRESS_TABLE_SCHEMA =
  "id, companyId, partnerId, isDefault, syncId"
